<div
    class="anc-field anc-field--select"
    [class.anc-field--floating]="floating()"
    [class.anc-field--focused]="focused()"
    [class.anc-field--readonly]="readonly()"
>
    @if (embeddedControl(); as ctrl) {
        <ng-select
            [formControl]="ctrl"
            [ariaLabel]="label() | translate"
            [labelForId]="inputId"
            [items]="items()"
            [bindLabel]="bindLabel()"
            [bindValue]="bindValue()"
            [clearable]="clearable()"
            [searchable]="searchable()"
            [readonly]="readonly()"
            [loading]="loading()"
            [multiple]="multiple()"
            [closeOnSelect]="closeOnSelect()"
            [notFoundText]="notFoundText() | translate"
            [virtualScroll]="virtualScroll()"
            [typeahead]="typeahead()"
            [appendTo]="appendTo() || null"
            [dropdownPosition]="dropdownPosition()"
            [addTag]="addTag()"
            [addTagText]="addTagText() || null"
            ancFieldValidate
            [ancFieldValidateSubmitted]="validateSubmitted()"
            (change)="onEmbeddedChange($event)"
            (search)="searchChange.emit($event)"
            (scrollToEnd)="scrollToEnd.emit()"
            (keydown)="keydown.emit($event)"
        >
            @if (multiple()) {
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    @if (shouldCollapseMultiLabels(items)) {
                        @for (item of visibleMultiLabels(items); track $index) {
                            <div class="ng-value anc-value-badge">
                                <span class="anc-value-badge__label">
                                    @if (translateOptions()) {
                                        {{ resolveSelectedValueLabel(item) | translate }}
                                    } @else {
                                        {{ resolveSelectedValueLabel(item) }}
                                    }
                                </span>
                                <span
                                    class="anc-value-badge__dismiss ng-value-icon right"
                                    (click)="clear(item); $event.stopPropagation()"
                                    aria-hidden="true"
                                >
                                    <span class="icon icon-close"></span>
                                </span>
                            </div>
                        }
                        <div class="ng-value anc-value-badge anc-value-badge--overflow">
                            <span class="anc-value-badge__label">+{{ remainingMultiLabelCount(items) }}</span>
                        </div>
                    } @else {
                        @for (item of items; track $index) {
                            <div class="ng-value anc-value-badge">
                                <span class="anc-value-badge__label">
                                    @if (translateOptions()) {
                                        {{ resolveSelectedValueLabel(item) | translate }}
                                    } @else {
                                        {{ resolveSelectedValueLabel(item) }}
                                    }
                                </span>
                                <span
                                    class="anc-value-badge__dismiss ng-value-icon right"
                                    (click)="clear(item); $event.stopPropagation()"
                                    aria-hidden="true"
                                >
                                    <span class="icon icon-close"></span>
                                </span>
                            </div>
                        }
                    }
                </ng-template>
            } @else if (translateOptions()) {
                <ng-template ng-label-tmp let-item="item">
                    {{ resolveOptionLabel(item) | translate }}
                </ng-template>
            }
            @if (translateOptions()) {
                <ng-template ng-option-tmp let-item="item">
                    {{ resolveOptionLabel(item) | translate }}
                </ng-template>
            }
            @if (multiple() && checkboxOptions()) {
                <ng-template
                    ng-option-tmp
                    let-item="item"
                    let-item$="item$"
                    let-index="index"
                >
                    <div class="filter-options">
                        <div>
                            <input
                                [id]="'anc-select-option-' + index"
                                type="checkbox"
                                [(ngModel)]="item$.selected"
                                [ngModelOptions]="{ standalone: true }"
                            />
                        </div>
                        <div class="filter-option-label">
                            {{ resolveOptionLabel(item) }}
                        </div>
                    </div>
                </ng-template>
            }
        </ng-select>
    } @else if (!controlName()) {
        <ng-content></ng-content>
    }
    <label class="anc-field__label" [attr.for]="embeddedControl() ? inputId : null" translate
        >{{ label() }}<sup class="super-star" *ngIf="required()">*</sup></label
    >
    @if (embeddedControl(); as ctrl) {
        @if (showEmbeddedRequiredError(ctrl)) {
            <div ancError>
                <div class="has-error" translate>{{ requiredErrorMessage() }}</div>
            </div>
        }
    }
    <ng-content select="[ancError]"></ng-content>
</div>
